// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For security, consider using environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Validate required Firebase configuration
const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);

if (missingKeys.length > 0) {
  throw new Error(
    `[Firebase Config] Missing required configuration keys: ${missingKeys.join(', ')}. ` +
    `Please check your .env file and ensure all VITE_FIREBASE_* variables are set.`
  );
}

console.log('[Firebase] Configuration validated successfully');

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const firestoreEmulatorHost = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST?.trim();
if (firestoreEmulatorHost) {
  const safeLocalHost = /^(?:127\.0\.0\.1|localhost):\d+$/.test(firestoreEmulatorHost);
  if (!import.meta.env.DEV || !firebaseConfig.projectId?.startsWith('demo-') || !safeLocalHost) {
    throw new Error(
      '[Firebase Config] Firestore emulator mode requires Vite DEV, a demo-* project id, and an exact localhost host:port.',
    );
  }
  const [host, portText] = firestoreEmulatorHost.split(':');
  connectFirestoreEmulator(db, host, Number(portText));
  console.log(`[Firebase] Firestore emulator connected at ${firestoreEmulatorHost} for ${firebaseConfig.projectId}`);
}
const functions = getFunctions(app, 'europe-west1');
const storage = getStorage(app);

export { app, auth, db, functions, storage };
